// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ResultsSection_wrapper__cAgwS"};